import { useContext } from "react";
import { StyleThemeContext } from "../contexts/style-theme.context";
import { DARK_MODE_STYLE, WHALE_MODE_STYLE } from "../utils/constants";

const ThemeToggler = () => {
  const { style, toggleTheme } = useContext(StyleThemeContext);

  return (
    <button
      className={"ms-sm-2 ms-1 btn btn-outline-dark" + (style === WHALE_MODE_STYLE ? " d-none" : "")}
      onClick={toggleTheme as any}>
      {style?.toLocaleUpperCase()?.split('-')[0]}
      <i className={"ms-1 fa-xs " + (style === DARK_MODE_STYLE ? "fas fa-moon" : "far fa-sun")}></i>
    </button>
  );
};

export default ThemeToggler;